<div style="height: 100%; width: 100%; background-color: aquamarine">
  <app-pdf-viewer #pdfViewer [pdfOptions]="options"></app-pdf-viewer>
</div>
